import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col flex-1" };
const _hoisted_2 = {
    key: 1,
    class: "flex flex-col gap-3"
};
import { computed } from "vue";
import ModuleState from "@/shared/components/ModuleState.vue";
import ContactRelationOrgCard from "./ContactRelationOrgCard.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactRelationsOrgTab',
    props: {
        organisations: {},
        canEdit: { type: Boolean },
        disabledTooltip: {}
    },
    emits: ["create-relation", "edit-relation", "delete-relation"],
    setup(__props) {
        const props = __props;
        function getMostRecentStart(org) {
            const activeFns = org.functions.filter((fn) => fn.endDate == null);
            const pool = activeFns.length > 0 ? activeFns : org.functions;
            if (pool.length === 0)
                return "";
            return pool.reduce((best, fn) => (fn.startDate > best.startDate ? fn : best)).startDate;
        }
        const sortedOrganisations = computed(() => [...props.organisations].sort((a, b) => getMostRecentStart(b).localeCompare(getMostRecentStart(a))));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (sortedOrganisations.value.length === 0)
                    ? (_openBlock(), _createBlock(ModuleState, {
                        key: 0,
                        type: "empty",
                        class: "flex-1 flex items-center justify-center",
                        title: _ctx.$t('contact.detail.relations.empty.title'),
                        description: _ctx.$t('contact.detail.relations.empty.description'),
                        "cta-icon": "ri-add-line",
                        "cta-label": _ctx.$t('contact.detail.relations.createRelation'),
                        "cta-disabled": !__props.canEdit,
                        "cta-disabled-tooltip": __props.disabledTooltip,
                        onCta: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('create-relation')))
                    }, null, 8 /* PROPS */, ["title", "description", "cta-label", "cta-disabled", "cta-disabled-tooltip"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedOrganisations.value, (org) => {
                            return (_openBlock(), _createBlock(ContactRelationOrgCard, {
                                key: org.id,
                                organisation: org,
                                onEditRelation: ($event) => (_ctx.$emit('edit-relation', org.id)),
                                onDeleteRelation: ($event) => (_ctx.$emit('delete-relation', org.id))
                            }, null, 8 /* PROPS */, ["organisation", "onEditRelation", "onDeleteRelation"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
            ]));
        };
    }
});
